import { AccountManagementFeatureConfig } from './AccountManagementFeatureConfig';

export const defaultAccountManagementFeatureConfig: AccountManagementFeatureConfig = {};
